
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import Carousel from '../../components/Carousel';
import NavLink from '../../components/NavLink';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  return (
      <div className="min-h-screen bg-white  transition-colors" style={{ fontFamily: 'Prompt, sans-serif' }}>
      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 bg-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-start py-4">
            <div className="flex items-start">
              <Logo size="md" className="hover:scale-105 transition-transform cursor-pointer" />
            </div>
            
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8 pt-4">
                  <NavLink to="/">HOME</NavLink>
                  <NavLink to="/about">ABOUT</NavLink>
                  <NavLink to="/services">SERVICES</NavLink>
                  <NavLink to="/products">PROJECTS</NavLink>
                  <NavLink to="/contact">CONTACT</NavLink>
              </div>
            </div>

            <div className="hidden md:flex items-center space-x-4 pt-4">
              <Link to="/contact" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer drop-shadow-lg">
                Get a Quote
              </Link>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-zbm-primary hover:text-zbm-primary-dark cursor-pointer drop-shadow-lg"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/95 /95 backdrop-blur-sm border-t border-gray-100 ">
              <NavLink to="/" mobile={true}>HOME</NavLink>
              <NavLink to="/about" mobile={true}>ABOUT</NavLink>
              <NavLink to="/services" mobile={true}>SERVICES</NavLink>
              <NavLink to="/products" mobile={true}>PROJECTS</NavLink>
              <NavLink to="/contact" mobile={true}>CONTACT</NavLink>
              <Link to="/contact" className="bg-zbm-secondary hover:bg-zbm-secondary-dark text-white px-6 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer w-full mt-2">
                Get a Quote
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Header Separator Line */}
      <div className="w-full h-px bg-gray-300 mt-32"></div>

      {/* Hero Section */}
      <section id="home" className="relative pt-20 pb-20 lg:pt-28 lg:pb-32" style={{ backgroundColor: '#F7F7F7' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="lg:text-left">
              <Carousel 
                className="w-full h-96 lg:h-[500px] shadow-2xl rounded-lg"
                autoPlay={true}
                interval={4000}
              />
            </div>
            <div className="text-left">
              <h1 className="text-4xl lg:text-6xl font-extrabold text-gray-900  mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>
                Building South Africa's
                <span className="text-zbm-primary block">Infrastructure</span>
                <span className="text-zbm-secondary">Future</span>
              </h1>
              <p className="text-xl text-gray-600  mb-8 leading-relaxed font-normal">
                ZBM Projects is a 100% Black-owned private company specializing in prefabricated structures, as well as civil and building construction projects. Since our inception, we've been dedicated to delivering high-quality infrastructure solutions that meet the needs of both the public and private sectors.
              </p>
              <div className="flex items-center mb-8">
                <span className="text-2xl mr-3">🏗️</span>
                <p className="text-lg font-semibold text-gray-700 " style={{ fontFamily: 'Prompt, sans-serif' }}>Quality. Innovation. Excellence.</p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/products" className="bg-zbm-primary hover:bg-zbm-primary-dark text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer text-center" style={{ fontFamily: 'Prompt, sans-serif' }}>
                  View Our Projects
                </Link>
                <Link to="/contact" className="border-2 border-zbm-secondary text-zbm-secondary hover:bg-zbm-secondary hover:text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer text-center" style={{ fontFamily: 'Prompt, sans-serif' }}>
                  Get a Quote
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <span className="text-3xl mr-3">🏢</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 " style={{ fontFamily: 'Prompt, sans-serif' }}>About ZBM Projects</h2>
            </div>
            <h3 className="text-2xl font-semibold text-zbm-primary mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Delivering Excellence in Construction</h3>
            <p className="text-xl text-gray-600  max-w-4xl mx-auto leading-relaxed font-normal">
              Led by Ms. Z. Dlamini, a young and ambitious entrepreneur whose journey began as a clerk at a construction firm, ZBM Projects has grown into a trusted provider of civil engineering and construction solutions. Our team brings together experienced professionals dedicated to delivering high-quality infrastructure that drives sustainable development.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            <div>
              <img 
                src="/projects/zbm-projects (3).jpeg"
                alt="ZBM Projects Construction Site"
                className="rounded-2xl shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Our Mission</h3>
                <p className="text-lg text-gray-600  leading-relaxed font-normal">
                  To design, build, and deliver infrastructure projects that meet the highest standards of quality, safety, and sustainability. We provide professional, cost-effective, and reliable construction services that exceed client expectations while supporting skills development and creating employment opportunities.
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Our Vision</h3>
                <p className="text-lg text-gray-600  leading-relaxed font-normal">
                  To be a leading and trusted provider of innovative civil engineering and construction solutions in South Africa, recognized for delivering high-quality infrastructure that drives sustainable development, empowers communities, and contributes to the country's economic growth.
                </p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Quality</h3>
              <p className="text-gray-600  font-normal">Highest standards in every project</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-zbm-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Innovation</h3>
              <p className="text-gray-600  font-normal">Embracing modern technology</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Partnership</h3>
              <p className="text-gray-600  font-normal">Building trust and integrity</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-zbm-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Excellence</h3>
              <p className="text-gray-600  font-normal">Professional delivery every time</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-gradient-to-br from-gray-50 to-zbm-light dark:from-gray-800 dark:to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <span className="text-3xl mr-3">🏗️</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 " style={{ fontFamily: 'Prompt, sans-serif' }}>Our Services</h2>
            </div>
            <h3 className="text-2xl font-semibold text-zbm-primary mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Comprehensive Construction Solutions</h3>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              From prefabricated structures to complete civil engineering projects, we deliver excellence in every aspect of construction.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mb-6">
                <i className="ri-clipboard-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Construction Project Management</h3>
              <ul className="text-gray-600  space-y-2 mb-6 font-normal">
                <li>• IBT Projects</li>
                <li>• Residential Development</li>
                <li>• Civil & Structural Engineering</li>
                <li>• RDP Projects</li>
              </ul>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-zbm-secondary rounded-full flex items-center justify-center mb-6">
                <i className="ri-building-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Building Construction</h3>
              <ul className="text-gray-600  space-y-2 mb-6 font-normal">
                <li>• Prefabricated Structures</li>
                <li>• Civil & Building Works</li>
                <li>• Foundations & Concrete Works</li>
                <li>• Carpentry & Finishing</li>
              </ul>
            </div>

            <div className="bg-white  p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-zbm-primary rounded-full flex items-center justify-center mb-6">
                <i className="ri-road-map-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900  mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Infrastructure & Utilities</h3>
              <ul className="text-gray-600  space-y-2 mb-6 font-normal">
                <li>• Water Reticulation Projects</li>
                <li>• Steel Works & Structures</li>
                <li>• Plant Hire Services</li>
                <li>• Power Floating & Saw Cuts</li>
              </ul>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link to="/services" className="bg-zbm-primary hover:bg-zbm-primary-dark text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              View All Services
            </Link>
          </div>
        </div>
      </section>

      {/* Projects Showcase Section */}
      <section id="projects" className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <span className="text-3xl mr-3">📋</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 " style={{ fontFamily: 'Prompt, sans-serif' }}>Featured Projects</h2>
            </div>
            <h3 className="text-2xl font-semibold text-zbm-primary mb-6" style={{ fontFamily: 'Prompt, sans-serif' }}>Proven Track Record of Excellence</h3>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto mb-8 font-normal">
              We've successfully delivered projects for government departments, municipalities, and private sector clients across South Africa.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-zbm-light to-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="p-6">
                <div className="w-12 h-12 bg-zbm-primary rounded-full flex items-center justify-center mb-4">
                  <i className="ri-government-line text-xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Siyamukela School Extension</h3>
                <p className="text-gray-600  text-sm font-normal mb-2">Independent Development Trust</p>
                <p className="text-gray-500  text-xs font-normal">Educational Infrastructure</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="p-6">
                <div className="w-12 h-12 bg-zbm-secondary rounded-full flex items-center justify-center mb-4">
                  <i className="ri-home-4-line text-xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Maluti Aphofung IBT Housing</h3>
                <p className="text-gray-600  text-sm font-normal mb-2">Local Municipality</p>
                <p className="text-gray-500  text-xs font-normal">Residential Development</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="p-6">
                <div className="w-12 h-12 bg-zbm-primary rounded-full flex items-center justify-center mb-4">
                  <i className="ri-water-flash-line text-xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Water Storage Tanks (45KL)</h3>
                <p className="text-gray-600  text-sm font-normal mb-2">Nostra Enviro Projects</p>
                <p className="text-gray-500  text-xs font-normal">Water Infrastructure</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="p-6">
                <div className="w-12 h-12 bg-zbm-secondary rounded-full flex items-center justify-center mb-4">
                  <i className="ri-building-2-line text-xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>Mearns Dam Offices House</h3>
                <p className="text-gray-600  text-sm font-normal mb-2">Dept. of Water & Sanitation</p>
                <p className="text-gray-500  text-xs font-normal">Commercial Building</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="p-6">
                <div className="w-12 h-12 bg-zbm-primary rounded-full flex items-center justify-center mb-4">
                  <i className="ri-book-line text-xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>NPP Library Renovations</h3>
                <p className="text-gray-600  text-sm font-normal mb-2">Dept. of Arts & Culture</p>
                <p className="text-gray-500  text-xs font-normal">Renovation Project</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-zbm-light to-white dark:from-gray-800 dark:to-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="p-6">
                <div className="w-12 h-12 bg-zbm-secondary rounded-full flex items-center justify-center mb-4">
                  <i className="ri-roadster-line text-xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900  mb-2" style={{ fontFamily: 'Prompt, sans-serif' }}>N3 SANRAL Steel Fixing</h3>
                <p className="text-gray-600  text-sm font-normal mb-2">Teichmann Structures</p>
                <p className="text-gray-500  text-xs font-normal">Road Infrastructure</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link to="/products" className="bg-zbm-primary hover:bg-zbm-primary-dark text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              View All Projects
            </Link>
          </div>
        </div>
      </section>

      {/* Partners/Clients Section */}
      <section className="py-20 bg-white ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <span className="text-3xl mr-3">🤝</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 " style={{ fontFamily: 'Prompt, sans-serif' }}>Our Valued Partners & Clients</h2>
            </div>
            <p className="text-xl text-gray-600  max-w-3xl mx-auto font-normal">
              Trusted by leading organizations and government departments across South Africa
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <div key={num} className="flex items-center justify-center p-4 bg-gray-50  rounded-lg hover:shadow-lg transition-shadow">
                <img 
                  src={`/partners/zbm-partners (${num}).jpeg`}
                  alt={`Partner ${num}`}
                  className="max-h-20 w-auto object-contain grayscale hover:grayscale-0 transition-all"
                />
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600  font-normal">
              We're proud to work with the Independent Development Trust, Department of Water and Sanitation, 
              Department of Arts and Culture, Department of Health KZN, and many more.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-2">
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>
                ZBM Projects
              </h3>
              <p className="text-gray-300 mb-6 max-w-md font-normal">
                A 100% Black-owned private company specializing in prefabricated structures, civil and building construction projects. Delivering high-quality infrastructure solutions across South Africa.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-zbm-primary hover:bg-zbm-primary-dark rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-zbm-secondary hover:bg-zbm-secondary-dark rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Services</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Project Management</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Building Construction</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Civil Engineering</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Prefabricated Structures</Link></li>
                <li><Link to="/services" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Water Infrastructure</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Prompt, sans-serif' }}>Company</h4>
              <ul className="space-y-2 text-gray-300 font-normal">
                <li><Link to="/" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/about" className="hover:text-zbm-primary-light transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/about#team" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Our Team</Link></li>
                <li><Link to="/products" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Projects</Link></li>
                <li><Link to="/contact" className="hover:text-zbm-primary-light transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm font-normal">
              © 2025 ZBM Projects. All Rights Reserved. Reg: 2016/321746/07
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}